import React, {useState} from "react";
import TaskMainContainer from "./TaskMainContainer";
import ChooseExtraItemTask from "./ChooseExtraItemTask";
import bgNature from '../images/greece-flowers-bg.png';

import imgTrue from "../images/сhooseExtraItemTask/scarecrow_true.png";
import imgFalse from "../images/сhooseExtraItemTask/scarecrow_false.png";


const GreeceBlocks4 = (props) => {
  const [allComplete, setAllComplete] = useState(false);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  const chooseTasks = [
    {
      title: 'There are two scarecrows in front of you. Their names are True and False. \n' +
        'True always tells the truth. False always lies. Press the scarecrow which lies.',
      titleFontSize: '3em',
      items: [
        {id: 1, image: imgTrue},
        {id: 2, image: imgFalse, success: true},
      ]
    },
    {
      title: '“All simple machines change the effort” \nWho said that?',
      items: [
        {id: 1, image: imgTrue},
        {id: 2, image: imgFalse, success: true},
      ]
    },
    {
      title: '“A single fixed pulley changes the direction of you pull” \nWho said that?',
      items: [
        {id: 1, image: imgTrue, success: true},
        {id: 2, image: imgFalse},
      ]
    },
    {
      title: '“Wheel and pulley are different names of the same machine” \nWho said that?',
      items: [
        {id: 1, image: imgTrue},
        {id: 2, image: imgFalse, success: true},
      ]
    },
  ]

  return (
    <TaskMainContainer
      lessonCode={props.lessonCode}
      tasksCount={chooseTasks.length}
      completeCount={completedTaskCount}
      setCompletedTaskCount={setCompletedTaskCount}
      taskComplete={allComplete}
    >

      {
        chooseTasks.map((item, i) => (
          <React.Fragment key={`step${i}`}>
            {
              ((completedTaskCount === (i)) || ((i+1) === chooseTasks.length && completedTaskCount >= chooseTasks.length)) ? (
                <ChooseExtraItemTask
                  lang={'en'}
                  bgImg={bgNature}
                  title={item.title}
                  titleFontSize={item.titleFontSize}
                  items={item.items}
                  taskComplete={() => {
                    setCompletedTaskCount(prevState => prevState + 1);
                    if ((i + 1) === chooseTasks.length) {
                      setAllComplete(true);
                    }
                  }}
                />
              ) : null
            }
          </React.Fragment>
        ))
      }
    </TaskMainContainer>
  )
}
export default GreeceBlocks4;
